import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-jalali';
import Calendar from './calendar';

import * as styles from '../styles';

class TimePicker extends React.PureComponent {
    static propTypes = {
        momentValue: PropTypes.object,
        setMomentValue: PropTypes.func,
    };

    state = {
        rawValue: (this.props.momentValue || moment()).format('HH:mm').persian(),
    }

    handleChange(value) {
        const {momentValue} = this.props;
        let newValue;

        if (momentValue) {
            newValue = momentValue.clone();
        } else {
            newValue = moment();
        }

        newValue.hour(value.split(':')[0]);
        newValue.minute(value.split(':')[1]);

        this.props.setMomentValue(newValue);
    }

    render() {
        const momentValue = this.props.momentValue || moment();
        return <div style={{marginBottom: 10}}>
            <input
                style={styles.numberInput}
                value={this.state.rawValue.persian()}
                onChange={({target: {value}}) => {
                    this.setState({rawValue: value.english()});
                    this.handleChange(value.english());
                }}
                onBlur={() => {
                    try {
                        this.setState({rawValue: momentValue.format('HH:mm')});
                    }
                    catch(e) {
                    }
                }}
            />
        </div>;
    }
}


export default class DatePicker extends React.PureComponent {
    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        defaultValue: PropTypes.object,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        children: PropTypes.node,
        min: PropTypes.object,
        max: PropTypes.object,
        defaultMonth: PropTypes.object,
        inputFormat: PropTypes.string,
        removable: PropTypes.bool,
        timePickerComponent: PropTypes.func,
        calendarStyles: PropTypes.object,
        calendarContainerProps: PropTypes.object,
        style: PropTypes.object,
        containerStyle: PropTypes.object,
        from: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    };

    static defaultProps = {
        calendarContainerProps: {},
        style: {},
        containerStyle: {},
        timePickerComponent: TimePicker,
    };

    state = {
        inputFormat: this.makeFormat(),
        isOpen: false,
        momentValue: this.props.defaultValue || null,
        inputValue: this.props.defaultValue ?
            this.props.defaultValue.format(this.makeFormat()) : '',
    };

    makeFormat() {
        return this.props.inputFormat ? this.props.inputFormat : this.props.timePickerComponent ? 'jYYYY/jM/jD - HH:mm' : 'jYYYY/jM/jD';
    }

    componentDidMount() {
        if (this.props.value) {
            this.setMomentValue(moment(this.props.value * 1000));
            this.setState({momentValue: moment(this.props.value * 1000)});
        }
    }

    componentWillReceiveProps(nextProps) {
        if ('value' in nextProps && nextProps.value !== this.props.value && nextProps.value) {
            this.setMomentValue(moment(nextProps.value * 1000));
            this.setState({momentValue: moment(nextProps.value * 1000)});
        }
    }

    setMomentValue(momentValue) {
        const {inputFormat} = this.state;

        if (this.props.onChange && this.props.value !== momentValue) {
            this.props.onChange(Math.floor(momentValue.toDate().getTime() / 1000));
        }
        else {
            this.setState({momentValue});
        }
        const inputValue = momentValue.format(inputFormat);
        this.setState({inputValue});
    }

    handleFocus() {
        this.setState({isOpen: true});
    }

    handleBlur(event) {
        const {onBlur} = this.props;
        const {isOpen, momentValue, inputFormat} = this.state;

        if (isOpen) {
        } else if (onBlur) {
            onBlur(event);
        }

        if (momentValue) {
            const inputValue = momentValue.format(inputFormat);
            this.setState({inputValue});
        }
    }

    handleClickOutsideCalendar() {
        this.setState({isOpen: false});
    }

    handleSelectDay(selectedMoment) {
        const {momentValue: oldValue} = this.state;
        let momentValue = selectedMoment.clone();

        if (oldValue) {
            momentValue = momentValue
                .set({
                    hour: oldValue.hours(),
                    minute: oldValue.minutes(),
                    second: oldValue.seconds(),
                });
        }

        this.setMomentValue(momentValue);
    }

    handleInputChange({target: {value}}) {
        const {inputFormat} = this.state;
        const inputValue = value.english();
        const momentValue = moment(inputValue, inputFormat);

        if (momentValue.isValid()) {
            this.setState({momentValue});
        }

        this.setState({inputValue});
    }

    handleInputClick() {
        if (!this.props.disabled) {
            this.setState({isOpen: true});
        }
    }

    renderInput() {
        const {inputValue} = this.state;

        return <input
            type='text'
            ref='input'
            style={this.props.style}
            onFocus={this.handleFocus.bind(this) }
            onBlur={this.handleBlur.bind(this) }
            onChange={this.handleInputChange.bind(this) }
            onClick={this.handleInputClick.bind(this) }
            value={inputValue.persian()}
        />;
    }

    renderCalendar() {
        const {momentValue} = this.state;
        const {timePickerComponent: TimePicker} = this.props;

        return (
            <div
                style={{
                    borderRadius: '3px',
                    boxShadow: '0 3px 10px #dbdbdb',
                    border: '1px solid #ccc',
                    width: '300px',
                    margin: 'auto',
                    textAlign: 'center',
                    padding: '10px',
                    backgroundColor: 'white',
                }}>
                <Calendar
                    min={this.props.min}
                    max={this.props.max}
                    selectedMoment={momentValue}
                    defaultMonth={this.props.defaultMonth}
                    onSelect={this.handleSelectDay.bind(this)}
                    onClickOutside={this.handleClickOutsideCalendar.bind(this)}
                    styles={this.props.calendarStyles}
                    containerProps={this.props.calendarContainerProps}
                    inputComponent={this.refs.input}
                    to={this.props.to}
                    from={this.props.from}>
                    {TimePicker
                        ? <TimePicker
                            min={this.props.min}
                            max={this.props.max}
                            momentValue={momentValue}
                            setMomentValue={this.setMomentValue.bind(this) }
                        />
                        : null
                    }
                </Calendar>
            </div>
        );
    }

    removeDate() {
        const {onChange} = this.props;
        if (onChange) {
            onChange('');
        }
        this.setState({
            input: '',
            inputValue: '',
        });
    }

    render() {
        const {isOpen} = this.state;

        return <div style={{position: 'relative', display: 'inline-block', ...this.props.containerStyle}}>
            {this.renderInput()}
            <div style={{position: 'absolute', top: '100%', right: '0', zIndex: '10'}}>
                {isOpen ? this.renderCalendar() : null}
            </div>
        </div>;
    }
}
